import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SubscriptionDone = ({ project, onBack, currentStatus, tracer }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("SUBSCRIPTION_DONE", {
    returnObjects: true,
  });
  return (
    <>
      <Navbar
        project={project}
        currentStatus={currentStatus}
        tracer={tracer}
        showHelp={false}
      />
      <View onBack={onBack} translate={TRANSLATION} />
    </>
  );
};

export default SubscriptionDone;
